<template>
    <div>
      <div class="loader" v-if="this.isLoading"></div>   
      <div class="loadertext" v-if="this.isLoading"> {{$t('loadingTxt')}}...</div>   
      <div class="main-wrapper" :class="{'blur-content': this.isLoading}">
  
          <!--begin::navbar-->
          <navbar-component></navbar-component>
          <!--end::navbar-->
  
        <div class="page-wrapper">
  
          <!--begin::content-->
          <div class="page-content">
            <div class="row">
              <div class="col-lg-12 col-xl-12 col-sm-12 col-xs-12 col-md-12">
                <div class="card">
                  <div class="card-header">
                        <!-- <i class="link-icon float-start" data-feather="arrow-left"></i> -->
                         &nbsp;&nbsp;&nbsp;
                        <h6 class="card-title mb-0 float-start" style="padding-left: 25px">{{ $t("rate_create") }}</h6>
                        <button
                          class="btn btn-default btn-sm float-end"
                          @click="resetForm"
                          type="button"
                        >
                        <i class="link-icon" data-feather="repeat"></i>
                          {{ $t("resetFormTxt") }}
                        </button>
                  </div>
                  <div class="card-body">
                    <form class="forms-sample" @submit.prevent="submitData" method="POST" >
                        
                        <div class="row justify-content-md-center px-3">
                            <!--left column-->
                            <div class="col md-6">
                                    <!--org_id-->
                                    <div class="row mb-3">
                                        <div class="col-md-5">
                                        <label for="defaultconfig" class="col-form-label">{{
                                        $t('organizationId')
                                        }}</label>
                                        </div>
                                        <div class="col">
                                        <input
                                        type="text"
                                        class="form-control"
                                        id="organizationId"
                                        :placeholder="$t('organizationId')"
                                        v-model="forms.organizationId"
                                        disabled
                                        />
                                        <div v-if="errors.organizationId">
                                        <div
                                            v-for="error in errors.organizationId"
                                            :key="error"
                                            class="alert alert-primary"
                                            role="alert"
                                        >
                                            <i data-feather="alert-circle"></i>
                                            {{ error }}
                                        </div>
                                        </div>
                                        </div>
                                    </div>
                                    <!--cust_id-->
                                    <div class="row mb-3">
                                        <div class="col-md-5">
                                            <label for="customerId" class="col-form-label">{{
                                                $t('customerId')}}
                                            </label>
                                        </div>
                                        <div class="col">
                                            <v-select
                                                @input="loadCustomerId"
                                                :options="fetchCustomer"
                                                v-model="customer"
                                                label="customerId"
                                                return-object
                                                @search="asyncSearchCustomer"
                                                >
                                                <template slot="option" slot-scope="option">
                                                    {{ option.udf02SAPCode }} | {{option.customerId}} | {{option.customerName}}
                                                </template>
                                            </v-select>
                                            <div v-if="errors.customerId">
                                                <div
                                                v-for="error in errors.customerId"
                                                :key="error"
                                                class="alert alert-primary"
                                                role="alert"
                                                >
                                                <i data-feather="alert-circle"></i>
                                                {{ error }}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <!--whid-->
                                    <div class="row mb-3">
                                <div class="col-md-5">
                                <label for="warehouseId" class="col-form-label">{{
                                    $t('warehouseId_txt')
                                }}</label>
                                </div>
                                <div class="col">
                                
                                <v-select
                                    @input="loadfulfillment"
                                    :options="fetchFulfillment"
                                    v-model="fulfillment"
                                    label="warehouseId"
                                    return-object
                                    @search="asyncSearchFulfillment"
                                    >
                                    <template slot="option" slot-scope="option">
                                        {{ option.warehouseId }} | {{option.WarehouseDescr}}
                                    </template>
                                    
                                </v-select>
        
        
        
                                <div v-if="errors.warehouseId">
                                    <div
                                    v-for="error in errors.warehouseId"
                                    :key="error"
                                    class="alert alert-primary"
                                    role="alert"
                                    >
                                    <i data-feather="alert-circle"></i>
                                    {{ error }}
                                    </div>
                                </div>
                                </div>
                                    </div>
                                    <!--ID Tarif Master Header-->
                                    <div class="row mb-3">
                                        <div class="col-md-5">
                                            <label for="idTarifMasterHeader" class="form-label">
                                            {{$t('idTarifMasterHeader')}}</label>
                                        </div>
                                        <div class="col">
                                        
                                        <v-select
                                            @input="loadtarifMasterId"
                                            :options="fetchtarifMasterId"
                                            v-model="forms.idTarifMasterHeader"
                                            label="tarifMasterId"
                                            return-object
                                            @search="asyncSearchtarifMasterId"
                                            >
                                        </v-select>
                
                
                
                                        <div v-if="errors.idTarifMasterHeader">
                                            <div
                                            v-for="error in errors.idTarifMasterHeader"
                                            :key="error"
                                            class="alert alert-primary"
                                            role="alert"
                                            >
                                            <i data-feather="alert-circle"></i>
                                            {{ error }}
                                            </div>
                                        </div>
                                        </div>
                                    </div>
                                    <!--opportunity--> 
                                    <div class="row mb-3">
                                <div class="col-md-5">
                                    <label for="opportunity_id" class="col-form-label">{{
                                        $t('opportunity_id')}}
                                    </label>
                                </div>
                                <div class="col">
                                    <v-select
                                        @input="loadOpportunity"
                                        :options="fetchOpportunity"
                                        v-model="opportunityId"
                                        label="opportunity_id"
                                        return-object
                                        @search="asyncSearchOpportunity"
                                        >
                                        <template slot="option" slot-scope="option">
                                            {{ option.agreement_no }} | {{option.opportunity_id}}
                                        </template>
                                    </v-select>
                                    <div v-if="errors.opportunity_id">
                                    <div
                                    v-for="error in errors.opportunity_id"
                                    :key="error"
                                    class="alert alert-primary"
                                    role="alert"
                                    >
                                    <i data-feather="alert-circle"></i>
                                    {{ error }}
                                    </div>
                                    </div>
                                </div>
                                    </div>
                                    <!--Status-->
                                    <div class="row mb-3">
                                        <div class="col-md-5">
                                            <label for="status" class="col-form-label">
                                                {{$t('statusTxt')}}
                                            </label>
                                        </div>
                                        <div class="col">
                                
                                <v-select
                                    :options="fetchStatus"
                                    v-model="forms.status"
                                    return-object
                                    ></v-select>
                                <div v-if="errors.status">
                                    <div
                                    v-for="error in errors.status"
                                    :key="error"
                                    class="alert alert-primary"
                                    role="alert"
                                    >
                                    <i data-feather="alert-circle"></i>
                                    {{ error }}
                                    </div>
                                </div>
                                        </div>
                                    </div>
                                    <!--additionalDataWMSFlag-->
                                    <div class="row mb-3">
                                        <div class="col-md-5">
                                            <label for="additionalDataWMSFlag" class="col-form-label">
                                                {{$t('additionalDataWMSFlag')}}
                                            </label>
                                        </div>
                                        <div class="col">
                                
                                <v-select
                                    :options="fetchYesOrNo"
                                    v-model="forms.additionalDataWMSFlag"
                                    return-object
                                    ></v-select>
                                <div v-if="errors.additionalDataWMSFlag">
                                    <div
                                    v-for="error in errors.additionalDataWMSFlag"
                                    :key="error"
                                    class="alert alert-primary"
                                    role="alert"
                                    >
                                    <i data-feather="alert-circle"></i>
                                    {{ error }}
                                    </div>
                                </div>
                                        </div>
                                    </div>
                                    <!--ratedesc-->
                                    <div class="row mb-3">
                                        <div class="col-md-5">
                                            <label for="rateDesc" class="col-form-label">
                                                {{$t('rateDesc')}}
                                            </label>
                                        </div>
                                        <div class="col">
                                            <textarea
                                                type="text"
                                                class="form-control"
                                                id="rateDesc"
                                                :placeholder="$t('rateDesc')"
                                                v-model="forms.rateDesc"
                                                rows="2"
                                                max-rows="5"
                                                required
                                            ></textarea>
                                            <div v-if="errors.rateDesc">
                                                <div
                                                v-for="error in errors.rateDesc"
                                                :key="error"
                                                class="alert alert-primary"
                                                role="alert"
                                                >
                                                <i data-feather="alert-circle"></i>
                                                {{ error }}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                            </div>
                            <!--right column-->
                            <div class="col md-6">
                                    <!--First Billing Date-->
                                    <div class="row mb-3">
                                        <div class="col-md-4">
                                            <label for="firstBilingDate" class="col-form-label">
                                                {{$t('firstBilingDate_txt')}}
                                            </label>
                                        </div>
                                        <div class="col">
                                            <span class="d-flex justify-content-start mdi mdi-calendar-month h2">
                                                <date-range-picker class="d-flex justify-content-end" style="width:100%" @update="firstDatesChange" control-container-class="form-control" :locale-data="locale" v-model="endDates" :opens="opens" :singleDatePicker="true" :timePicker24Hour="false" :timePicker="false" :showWeekNumbers="false"></date-range-picker>
                                            </span>
                                            <div v-if="errors.firstBilingDate">
                                                <div
                                                v-for="error in errors.firstBilingDate"
                                                :key="error"
                                                class="alert alert-primary"
                                                role="alert"
                                                >
                                                <i data-feather="alert-circle"></i>
                                                {{ error }}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <!--cust_sap_code-->
                                    <div class="row mb-3">
                                <div class="col-md-4">
                                <label for="customerSAPCode" class="col-form-label">{{
                                    $t('customerSAPCode')
                                }}</label>
                                </div>
                                <div class="col">
                                <input
                                    type="text"
                                    class="form-control"
                                    id="customerSAPCode"
                                    :placeholder="$t('customerSAPCode')"
                                    v-model="forms.customerSAPCode"
                                    disabled
                                />
                                <div v-if="errors.customerSAPCode">
                                    <div
                                    v-for="error in errors.customerSAPCode"
                                    :key="error"
                                    class="alert alert-primary"
                                    role="alert"
                                    >
                                    <i data-feather="alert-circle"></i>
                                    {{ error }}
                                    </div>
                                </div>
                                </div>
                                    </div>
                                    <!--Tarif Master ID-->
                                    <div class="row mb-3">
                                        <div class="col-md-4">
                                            <label for="tarifMasterId" class="col-form-label">
                                                {{$t('tarifMasterId')}}
                                            </label>
                                        </div>
                                        <div class="col">
                                
                                <input type="text" class="form-control" id="tarifMasterId" :placeholder="$t('tarifMasterId')" v-model="forms.tarifMasterId" disabled/>
        
        
        
                                <div v-if="errors.tarifMasterId">
                                    <div
                                    v-for="error in errors.tarifMasterId"
                                    :key="error"
                                    class="alert alert-primary"
                                    role="alert"
                                    >
                                    <i data-feather="alert-circle"></i>
                                    {{ error }}
                                    </div>
                                </div>
                                        </div>
                                    </div>
                                    <!--contract no-->
                                    <div class="row mb-3">
                                <div class="col-md-4">
                                    <label for="rateName" class="col-form-label">
                                        {{$t('contract_no')}}
                                    </label>
                                </div>
                                <div class="col">
                                    <input type="text" class="form-control" id="rateName" :placeholder="$t('contract_no')" v-model="forms.rateName" disabled/>
                                        <div v-if="errors.rateName">
                                            <div v-for="error in errors.rateName"
                                                :key="error"
                                                class="alert alert-primary"
                                                role="alert"
                                                >
                                                <i data-feather="alert-circle"></i>
                                                {{ error }}
                                            </div>
                                        </div>
                                </div>
                                    </div>
                                    <!--Effective From Date-->
                                    <div class="row mb-3">
                                <div class="col-md-4">
                                    <label for="effectiveFromDate" class="col-form-label">
                                        {{$t('effectiveFromDate')}}
                                    </label>
                                </div>
                                <div class="col">
                                    <input type="text" class="form-control" id="effectiveFromDate" :placeholder="$t('effectiveFromDate')" v-model="forms.effectiveFromDate" disabled/>
                                        <div v-if="errors.effectiveFromDate">
                                            <div v-for="error in errors.effectiveFromDate"
                                                :key="error"
                                                class="alert alert-primary"
                                                role="alert"
                                                >
                                                <i data-feather="alert-circle"></i>
                                                {{ error }}
                                            </div>
                                        </div>
                                </div>
                                    </div>
                                    <!--Effective To Date-->
                                    <div class="row mb-3">
                                <div class="col-md-4">
                                    <label for="effectiveToDate" class="col-form-label">
                                        {{$t('effectiveToDate')}}
                                    </label>
                                </div>
                                <div class="col">
                                    <input type="text" class="form-control" id="effectiveToDate" :placeholder="$t('effectiveToDate')" v-model="forms.effectiveToDate" disabled/>
                                        <div v-if="errors.effectiveToDate">
                                            <div v-for="error in errors.effectiveToDate"
                                                :key="error"
                                                class="alert alert-primary"
                                                role="alert"
                                                >
                                                <i data-feather="alert-circle"></i>
                                                {{ error }}
                                            </div>
                                        </div>
                                </div>
                                    </div>
                                    <!--sapDataFlag-->
                                    <div class="row mb-3">
                                        <div class="col-md-4">
                                            <label for="sapDataFlag" class="col-form-label">
                                                {{$t('sapDataFlag')}}
                                            </label>
                                        </div>
                                        <div class="col">
                                
                                <v-select
                                    :options="fetchYesOrNo"
                                    v-model="forms.sapDataFlag"
                                    return-object
                                    ></v-select>
                                <div v-if="errors.sapDataFlag">
                                    <div
                                    v-for="error in errors.sapDataFlag"
                                    :key="error"
                                    class="alert alert-primary"
                                    role="alert"
                                    >
                                    <i data-feather="alert-circle"></i>
                                    {{ error }}
                                    </div>
                                </div>
                                        </div>
                                    </div>
                                    <!--billingPeriode-->
                                    <div class="row mb-3">
                                        <div class="col-md-4">
                                            <label for="billingPeriode" class="col-form-label">
                                                {{$t('billingPeriode')}}
                                            </label>
                                        </div>
                                        <div class="col">
                                
                                <v-select
                                    :options="fetchBillingPeriode"
                                    v-model="forms.billingPeriode"
                                    return-object
                                    ></v-select>
                                <div v-if="errors.billingPeriode">
                                    <div
                                    v-for="error in errors.billingPeriode"
                                    :key="error"
                                    class="alert alert-primary"
                                    role="alert"
                                    >
                                    <i data-feather="alert-circle"></i>
                                    {{ error }}
                                    </div>
                                </div>
                                        </div>
                                    </div>
                            </div>
                        </div>

                        <!--ratedesc-->
                        <!--<div class="row mb-3 justify-content-md-center px-3">
                            <div class="col-md-2">
                            <label for="rateDesc" class="col-form-label">{{
                                $t('rateDesc')
                            }}</label>
                            </div>
                            <div class="col">
                            <input
                                type="text"
                                class="form-control"
                                id="rateDesc"
                                :placeholder="$t('rateDesc')"
                                v-model="forms.rateDesc"
                                required
                            />
                            
                            <div v-if="errors.rateDesc">
                                <div
                                v-for="error in errors.rateDesc"
                                :key="error"
                                class="alert alert-primary"
                                role="alert"
                                >
                                <i data-feather="alert-circle"></i>
                                {{ error }}
                                </div>
                            </div>
                            </div>
                        </div>-->
                                
                        <!--<div class="row mb-3">
                        <div class="col-lg-2">
                          <label for="defaultconfig" class="col-form-label" style="padding-left: 25px">{{
                            $t('effectiveDate_txt')
                          }}</label>
                        </div>
                        <div class="col-lg-8">
  
                          <date-range-picker style="width:100%" @update="fromDatesChange" control-container-class="form-control" :locale-data="locale" v-model="fromDates" :opens="opens" :singleDatePicker="false" :timePicker24Hour="false" :timePicker="false" :showWeekNumbers="false"></date-range-picker>
  
                          <div v-if="errors.effectiveFromDate">
                            <div
                              v-for="error in errors.effectiveFromDate"
                              :key="error"
                              class="alert alert-primary"
                              role="alert"
                            >
                              <i data-feather="alert-circle"></i>
                              {{ error }}
                            </div>
                          </div>
  
                        </div>
                      </div>-->
  
                        <div class="card-footer">
                        <button
                          class="
                            btn btn-warning
                            text-black
                            fw-bolder
                            btn-icon-text
                          "
                          @click="backForm"
                          type="button"
                        >
                          <i class="link-icon" data-feather="arrow-left"></i>
                          {{ $t("backMess") }}
                        </button>
                        &nbsp;&nbsp;&nbsp;
                        <button class="btn btn-primary float-end btn-sm" type="submit">
                             <i class="link-icon" data-feather="save"></i>
                          {{ $t("submitFormTxt") }}
                        </button>
                        </div>

                    </form>
                  </div>
                </div> <!--end::card-->
              </div>
            </div>
          </div>
          <!--end::content-->
  
          <!--begin::footer-->
          <footer-component></footer-component>
          <!--end::footer-->
        </div>
      </div>
    </div>
</template>
  
  
  <script>
  import navbarComponent from "@/components/_partials/_navbar";
  import footerComponent from "@/components/_partials/_footer";
  import DateRangePicker from 'vue2-daterange-picker';
  
  export default {
    name        : "CmlRateHeaderAdd",
    props       : {},
    components  : 
    {
      "navbar-component"    : navbarComponent,
      "footer-component"    : footerComponent,
      DateRangePicker,
    },
    data() 
    {
      const startDate   = new Date();
      const endDate     = new Date();
      endDate.setDate(endDate.getDate() + 24);
  
      return {
        opens       : "center",
        locale      : 
        {
          format:"yyyy-mm-dd",
        
        },
        fromDates   : 
        {
          startDate : startDate,
          endDate   : endDate
        },
        endDates    : 
        {
          startDate : "",
          endDate   : ""
        },
        highlighted :
        {
            dates   : [ // Highlight an array of dates
              new Date(),
            ],
  
        },
        disabledAfter       : new Date(2019, 10, 6),
        permision_role      : [],
        isLoading           : false,
        maxToasts           : 100,
        position            : "up right",
        closeBtn            : true,
        errors              : [],
        fetchStatus         : ['ACTIVE','DISABLED'],
        fetchBillingPeriode : ['Cut Off 25','Cut Of End Of Month'],
        fetchYesOrNo        : ['Y','N'],
        fetchtarifMasterId  : [],
        fetchCustomer       : [],
        fetchOpportunity    : [],
        fetchFulfillment    : [],
        company_group       : "",
        tarifMasterId       : "",
        customer            : "",
        opportunityId       : "",
        fulfillment         : "",
        userData            : "",
        userRole            : "",
        companyCode         : "",
        forms               : { sapDataFlag:"N", additionalDataWMSFlag:"N", billingPeriode:"Cut Off 25", opportunity_id:"", idRateHeader: "",rateName:"" , warehouseId:"", customerId:"", organizationId:"OJV_CML", customerSAPCode:"", firstBilingDate:"", effectiveFromDate:"", effectiveToDate:"", status:"DISABLED", addwho:"",  editwho:"",  rateDesc:"", idTarifMasterHeader:"",tarifMasterId:""},
      };
    },
    watch   : {},
    methods : 
    {


        loadCustomerId(value)
        {
            this.forms.customerId = value.customerId
            this.forms.customerSAPCode = value.udf02SAPCode
            this.getTariffMaster()
        },
    
        loadOpportunity(value)
        {
            this.forms.opportunity_id = value.opportunity_id
            this.forms.rateName = value.agreement_no
            this.forms.effectiveFromDate = value.effective_from
            this.forms.effectiveToDate = value.effective_to
        },

        loadfulfillment(value)
        {
            this.forms.warehouseId = value.warehouseId
            this.getOpportunity()
        },

        loadtarifMasterId(value)
        {
            this.forms.idTarifMasterHeader  = value.idTarifMasterHeader
            this.forms.tarifMasterId        = value.tarifMasterId
        },
  
        fromDatesChange()
        {
    
            if(this.fromDates.startDate && this.fromDates.endDate){
            this.forms.effectiveFromDate=this.$moment(String(this.fromDates.startDate)).format('YYYY-MM-DD');
            this.forms.effectiveToDate=this.$moment(String(this.fromDates.endDate)).format('YYYY-MM-DD');
            }
            
        },
      
        firstDatesChange()
        {
            if(this.endDates.startDate){
            this.forms.firstBilingDate=this.$moment(String(this.endDates.startDate)).format('YYYY-MM-DD');
            }
        },
      
        dateFormat (classes, date) 
        {
            if (!classes.disabled) {
            classes.disabled = date.getTime() < new Date();
            }
            return classes;
        },
  
        getFulfillment()
        {
    
            const baseURI = this.$settings.endPointBilling + "dashboard/cml-billing/warehouse/get-data";

            return this.$http
            .get(
                baseURI,{ timeout: 60000 }
            )
            .then((response) => {
                this.fetchFulfillment = response.data.datas.data;
            }).catch(error => {

                if(error.code == "ECONNABORTED"){
                this.error("Please Check Your Internet Connection");
                }

            });
        },

        asyncSearchFulfillment()
        {
    
    
            const baseURI = this.$settings.endPointBilling + "dashboard/cml-billing/warehouse/get-data?download=all";
        
            return this.$http
            .get(
                baseURI,{ timeout: 60000 }
            )
            .then((response) => {
                this.opportunityId              = "";
                this.forms.rateName             = "";
                this.forms.effectiveFromDate    = "";
                this.forms.effectiveToDate      = "";
                this.fetchFulfillment           = response.data.datas;
            }).catch(error => {
    
                if(error.code == "ECONNABORTED"){
                this.error("Please Check Your Internet Connection");
                }
    
            });
        },
  
        getCustomer()
        {
    
            const baseURI = this.$settings.endPointBilling + "dashboard/cml-billing/customer/get-data";

            return this.$http
            .get(
                baseURI,{ timeout: 60000 }
            )
            .then((response) => {
                this.fetchCustomer = response.data.datas.data;
            }).catch(error => {

                if(error.code == "ECONNABORTED"){
                this.error("Please Check Your Internet Connection");
                }

            });
        },
  
        asyncSearchCustomer()
        {
    
            const baseURI = this.$settings.endPointBilling + "dashboard/cml-billing/customer/get-data?download=all";
        
            return this.$http
            .get(
                baseURI,{ timeout: 60000 }
            )
            .then((response) => {
                this.tarifMasterId              = "";
                this.forms.idTarifMasterHeader  = "";
                this.forms.tarifMasterId        = "";
                this.opportunityId              = "";
                this.forms.rateName             = "";
                this.forms.effectiveFromDate    = "";
                this.forms.effectiveToDate      = "";
                this.fetchCustomer              = response.data.datas;
            }).catch(error => {
    
                if(error.code == "ECONNABORTED"){
                this.error("Please Check Your Internet Connection");
                }
    
            });
        },

        getOpportunity()
        {
    
            const baseURI = this.$settings.endPointBilling + `dashboard/cml-billing/rate/header/get-data-opportunity?customer_code=${this.customer.udf02SAPCode}&warehouse_code=${this.fulfillment.warehouseId}`;

            return this.$http
            .get(
                baseURI,{ timeout: 60000 }
            )
            .then((response) => {
                this.fetchOpportunity = response.data.datas.data;
            }).catch(error => {

                if(error.code == "ECONNABORTED"){
                this.error("Please Check Your Internet Connection");
                }

            });

        }, 

        asyncSearchOpportunity()
        {
    
            const baseURI = this.$settings.endPointBilling + `dashboard/cml-billing/rate/header/get-data-opportunity?customer_code=${this.customer.udf02SAPCode}&warehouse_code=${this.fulfillment.warehouseId}`;
        
            return this.$http
            .get(
                baseURI,{ timeout: 60000 }
            )
            .then((response) => {
                this.fetchOpportunity = response.data.datas;
            }).catch(error => {
    
                if(error.code == "ECONNABORTED"){
                this.error("Please Check Your Internet Connection");
                }
    
            });
        },
  
        getTariffMaster()
        {
    
            const baseURI = this.$settings.endPointBilling + `dashboard/cml-billing/bm-tarif-master-cml/get-data?customerId=${this.customer.customerId}`;

            return this.$http
            .get(
                baseURI,{ timeout: 60000 }
            )
            .then((response) => {
                this.fetchtarifMasterId = response.data.datas.data;
            }).catch(error => {

                if(error.code == "ECONNABORTED"){
                this.error("Please Check Your Internet Connection");
                }

            });
        },

        asyncSearchtarifMasterId()
        {
    
            const baseURI = this.$settings.endPointBilling + `dashboard/cml-billing/bm-tarif-master-cml/get-data?customerId=${this.customer.customerId}`;
        
            return this.$http
            .get(
                baseURI,{ timeout: 60000 }
            )
            .then((response) => {
                this.fetchtarifMasterId=response.data.datas;
            }).catch(error => {
    
                if(error.code == "ECONNABORTED"){
                this.error("Please Check Your Internet Connection");
                }
    
            });
        },
  
        resetForm() 
        {
    
            this.forms.bm_rate_detail             = [];
            this.forms.idRateHeader               = "";
            this.forms.warehouseId                = "";
            this.forms.customerId                 = "";
            this.forms.organizationId              = "OJV_CML";
            this.forms.customerSAPCode            = "";
            this.forms.firstBilingDate            = "";
            this.forms.effectiveFromDate          = "";
            this.forms.effectiveToDate            = "";
            this.forms.idTarifMasterHeader        = "";
            this.forms.tarifMasterId              = "";
            this.forms.status                     = "";
            this.forms.addwho                     = "";
            this.forms.editwho                    = "";
            this.forms.opportunity_id             = "";
            this.forms.rateName                   = "";
            this.forms.rateDesc                   = "";
            this.tarifMasterId                    = "";
            this.customer                         = "";
            this.opportunityId                    = "";
            this.fulfillment                      = "";
            this.endDates                         = null;
    
        },
  
        fetchIt() 
        {
            const userDatas     = this.$getUserInfo();
            this.userData       = userDatas.sub;
            this.userRole       = userDatas.sub.role;
            // this.permision_role = userDatas.sub.permision_role;
            let rolePermision = [];
            userDatas.sub.permision_role.forEach(function(permision){
            if(permision.permission.controller == 'RateHeaderCmlController'){
                rolePermision = permision;
            }
            });
    
            if(!rolePermision.method_create){
            this.$router.push("/authorized-error");
            }
            this.permision_role = rolePermision;
            this.getCustomer();
            this.getFulfillment();
            
    
        },
  
        backForm() 
        {
            window.location.href = "/billing-cml/rates/header";
        },
  
        submitData() 
        {
                this.isLoading = true;
    
                const baseURI  =  this.$settings.endPointBilling+"dashboard/cml-billing/rate/header/create";
                this.$http.post(baseURI,this.forms,{ timeout: 60000 }).then((response) => {
                    this.loading();
                    if(response.data.status === 200) {
                    //this.resetForm();
                        this.isLoading = false;
                        this.errors = [];
                        //console.log(response.data.datas.user_id);
                        var params = this.$onRandom(response.data.datas.idRateHeader);
                        window.location.href = "/billing-cml/rates/header/detail/" + params + "?status=200&msg=Successfully";
                        // this.success('Berhasil');
                    }else{
                        this.isLoading = false;
                        this.errors = response.data.errors;
                        this.resultError(response.data.errors);
                    }
                }).catch(error => {
                    this.loading();
                    this.isLoading = false;
                    if(error.code == "ECONNABORTED"){
                        this.error(this.$t("check_internet_connection_txt"));
                        
                    }else{

                        if (error.response) {
                            if(error.response.status === 422) {
                                this.errors = error.response.data.errors;
                                this.resultError(error.response.data.errors);
                            }else if (error.response.status === 401) {
                                this.logout();
                            } else if (error.response.status === 403) {
                                this.$router.push("/authorized-error");
                            }else if (error.response.status === 500) {
                                this.$router.push('/server-error');
                            }else{
                                this.$router.push('/page-not-found');
                            }
                        }

                    }
                    //this.resetForm();
                });
        },
  
        logout()
        {

            const baseURI = this.$settings.endPoint + "user/logout";
            this.$http.get(baseURI, { timeout: 60000 }).then((response) => {
                
            console.log(response);

            });

            this.$logoutUser();
            window.location.href = '/';
        },

        fade(sType) 
        {
            this.isLoading = sType;
        },
  
        loading() 
        {
            this.fade(true);
            setTimeout(() => {
            this.fade(false);
            }, 1000); // hide the message after 3 seconds
        },
  
        resultError(data) 
        {
            var count = Object.keys(data).length;
            for (var x = 0; x < count; x++) {
            var nameOb = Object.keys(data)[x];
            var objectData = data[nameOb];
            for (var y = 0; y < objectData.length; y++) {
                this.error(objectData[y]);
            }
            }
        },
  
        success(kata) 
        {
            const Toast = this.$swal.mixin({
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            timer: 3000,
            timerProgressBar: true,
            didOpen: (toast) => {
                toast.addEventListener("mouseenter", this.$swal.stopTimer);
                toast.addEventListener("mouseleave", this.$swal.resumeTimer);
            },
            });
            Toast.fire({
            icon: "success",
            title: kata,
            });
        },
  
        error(kata) 
        {
            const Toast = this.$swal.mixin({
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            timer: 3000,
            timerProgressBar: true,
            didOpen: (toast) => {
                toast.addEventListener("mouseenter", this.$swal.stopTimer);
                toast.addEventListener("mouseleave", this.$swal.resumeTimer);
            },
            });
            Toast.fire({
            icon: "error",
            title: kata,
            });
        },


    },
    events  : {},
    created : function () {},
    mounted() 
    {
      this.fetchIt();
    },

  };

  </script>


  <style scoped>
  
  </style>